import React from 'react';

const Logo = ({ size = 'medium', variant = 'default' }) => {
  const sizes = {
    small: { width: 120, height: 40, fontSize: '18px' },
    medium: { width: 160, height: 50, fontSize: '24px' },
    large: { width: 200, height: 60, fontSize: '28px' }
  };

  const currentSize = sizes[size];

  return (
    <div className={`logo logo-${variant}`} style={{ width: currentSize.width, height: currentSize.height }}>
      <svg viewBox="0 0 160 50" className="logo-svg">
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0066cc" />
            <stop offset="100%" stopColor="#3399ff" />
          </linearGradient>
        </defs>
        
        {/* Modern geometric design */}
        <rect x="0" y="10" width="8" height="30" fill="url(#logoGradient)" rx="2" />
        <rect x="12" y="5" width="8" height="40" fill="url(#logoGradient)" rx="2" />
        <rect x="24" y="15" width="8" height="20" fill="url(#logoGradient)" rx="2" />
        
        {/* Company name */}
        <text x="40" y="32" fontSize={currentSize.fontSize} fontWeight="700" fill="#1a1a1a" fontFamily="Inter, sans-serif">
          AuVSys
        </text>
      </svg>
      <div className="logo-tagline" style={{ fontSize: `${parseInt(currentSize.fontSize) * 0.4}px` }}>
        Global Technology Services
      </div>
    </div>
  );
};

export default Logo;